import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import {TextBlock, RoundShape} from 'react-placeholder/lib/placeholders';

import {
	makeStyles,
	Typography,
	Grid,
	Button,
	useTheme,
	useMediaQuery
} from '@material-ui/core';

import Comment from './Comment.js';
import AddCommentForm from "./AddCommentForm";
//import ActivityActions from './ActivityActions.js';
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import Constants from "../utils/Constants";

const transitionDuration = 250;
const styles = makeStyles(theme => ({
	commentsNote: {
		marginTop: "20px"
	},

	commentForm: {
		transition: `max-width ${transitionDuration/1000}s ease, flex-basis 0.5s ease`
	},

	growCommentForm: {
		[theme.breakpoints.down('sm')]: {
			maxWidth: "100%",
			flexBasis: "100%"
		}
	},

	bottomRowButton: {
		marginTop: theme.spacing(1.25),
	},

	buttonGrid: {
		paddingTop: theme.spacing(1)
	},

	noComments: {
		color: theme.palette.grey[500],
		fontSize: "0.85rem"
	},
	teamComment: {
		fontWeight: 500,
		color: Constants.COLORS.PRIMARY.DARK_GREY,
	},
}));

const placeholderColor = Constants.COLORS.PLACEHOLDER_BG;
const commentPlaceholder = (
	<div style={{display: "flex", alignItems: "center", marginTop: 25}}>
		<div style={{marginRight: 10}}>
			<RoundShape color={placeholderColor} style={{height: 48, width: 48}} />
		</div>
		<div style={{flex: 1}}>
			<TextBlock rows={2} color={placeholderColor} />
		</div>
	</div>
);

function Comments(props) {
	const theme = useTheme();
	const authenticatedUser = useContext(AuthorizedUserContext);
	const [loadMore, setLoadMore] = useState(false);
	const [commentFieldFocused, setCommentFieldFocused] = useState(false);
	const [commentFieldBlurred, setCommentFieldBlurred] = useState(false);
	const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

	const commentFieldHasFocus = () => {
		if (isSmall) {
			setCommentFieldFocused(true);
		}
	};

	const commentFieldWasBlurred = () => {
		if (isSmall) {
			setCommentFieldBlurred(true);
			setTimeout(() => {
				setCommentFieldFocused(false);
				setCommentFieldBlurred(false);
			}, transitionDuration);
		}
	};

	let commentsArray = [],
		classes = styles(),
		{ready, fidoError, isActivityDeleted,
			className, comments, numberToShow, allowViewMore, addCommentHandler} = props;

	if (comments && comments.length) {
		if (numberToShow == null || numberToShow > comments.length || loadMore) {
			numberToShow = comments.length;
		}

		// Dynamic length calls for "for" loop
		for (let i=0; i<numberToShow; i++) {
			commentsArray.push(<Comment ready={ready} key={comments[i].id} {...comments[i]} />);
		}

		if (!allowViewMore) {
			let more = comments.length-1;
			if (more > 0) {
				commentsArray.push(
					<Typography
						key="commentsCount"
						onClick={props.moreCommentsClickHandler} // TODO: comments should prob be refactored to break some of this logic apart
						className={`${classes.secondary} ${classes.commentsNote}`}>{more} more comments</Typography>
				);
			}
		}
	}

	if (comments && comments.length && allowViewMore) {
		let x = comments.length - commentsArray.length;
		commentsArray.push(
			<Grid
				container
				key="buttonContainer"
				justify="space-between"
				className={classes.buttonGrid}>
				<Grid item>
					{!loadMore && commentsArray.length !== comments.length && x > 0 ? (
						<Button
							color="primary"
							onClick={() => setLoadMore(true)}
							className={classes.bottomRowButton}>
							{x} More Comments
						</Button>
					) : null}
				</Grid>
				<Grid item>
					<div className={classes.bottomRowButton}>
						{props.bottomRowButton}
					</div>
				</Grid>
			</Grid>
		);
	}

	return (
		<div className={`${className}`}>
			{authenticatedUser && comments ? (
				<div className={`${classes.commentForm} ${commentFieldFocused && !commentFieldBlurred ? classes.growCommentForm : ""}`}>
					{isActivityDeleted || addCommentHandler == null ? (
						comments.length ? (
							<Typography>Comments:</Typography>
						) : (
							<Typography className={classes.noComments}>No Comments</Typography>
						)
					) : (
						<ReactPlaceholder
							type='rect'
							ready={ready}
							style={{height: 30, borderRadius: 20}}>
							<Typography className={classes.teamComment}>Team Comment</Typography>
							<AddCommentForm
								addCommentHandler={addCommentHandler}
								focusHandler={commentFieldHasFocus}
								blurHandler={commentFieldWasBlurred} />
						</ReactPlaceholder>
					)}
				</div>
			) : null }
			{authenticatedUser && comments ?
				commentsArray
				: 
				<ReactPlaceholder
					ready={ready}
					customPlaceholder={commentPlaceholder}
					showLoadingAnimation={!fidoError}><span></span></ReactPlaceholder>
			}
		</div>
	);
}

Comments.propTypes = {
	className: PropTypes.string,
	ready: PropTypes.bool,
	comments: PropTypes.array,
	numberToShow: PropTypes.number,
	addCommentHandler: PropTypes.func,
	allowViewMore: PropTypes.bool,
	fidoError: PropTypes.bool,
	moreCommentsClickHandler: PropTypes.func,
	bottomRowButton: PropTypes.object,
	isActivityDeleted: PropTypes.bool
};

export default Comments;
